import { GlobalModalLazy } from 'shared/global-modal/ui'

import { Outlet } from 'react-router-dom'

import ErrorHoc from 'shared/ui/ErrorBoundary/lib/ErrorHoc'

import { AntProvider } from 'shared/config/ant/ui/AntProvider/AntProvider'
import { StoreProvider } from 'shared/config/redux/provider/StoreProvider'
import 'shared/config/styles/global.css'

const GlobalLayout = () => {
  return (
    <ErrorHoc>
      <StoreProvider>
        <AntProvider>
          <Outlet />
          <GlobalModalLazy />
        </AntProvider>
      </StoreProvider>
    </ErrorHoc>
  )
}

export default GlobalLayout
